import { render, staticRenderFns } from "./form18.vue?vue&type=template&id=0c18686a&scoped=true"
import script from "./form18.vue?vue&type=script&lang=js"
export * from "./form18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18686a",
  null
  
)

export default component.exports